import { Grid, Link, makeStyles, Theme, Typography } from "@material-ui/core";
import React from "react";
import careerImage from "./Assets/career.svg";
import clockImage from "./Assets/clock.svg";
import downloadImage from "./Assets/download.svg";
import learningImage from "./Assets/learning.svg";
import mobileImage from "./Assets/mobile.svg";
import navigationImage from "./Assets/navigation.svg";
import payImage from "./Assets/pay.svg";
import talentImage from "./Assets/talent.svg";
import videoImage from "./Assets/video.svg";
import Categories from "./Categories";
import CategoryData from "./CategoryData";
import ContactInformation from "./WDContactInformation";

const useStyles = makeStyles((theme: Theme) => ({}));

const categories = [
  {
    title: "HS Learning Partner",
    icon: navigationImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "Enroll Employee in Digital Course",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0f45ffb4-9055-47a8-a053-343d47329441",
          },
          {
            title: "Enroll Employee in Blended Course Offering",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/8b7fd52c-8860-4895-acd0-6b438b30c724",
          },
          {
            title: "EL Learning Class Status Report",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0f03e424-c5f1-4417-8674-f49dfeecb49b",
          },
          {
            title: "Drop Employee From Digital Course",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/f9811d9e-82e9-4429-924d-db8e075c589a",
          },
          {
            title: "Drop Employee From Blended Course",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/3664c3f7-db07-40fe-9c22-d27f8a8706f4",
          },
          {
            title: "Schedule a Blended Course Offering",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/71bc7bdd-7d3d-495e-852c-b94c5b2aac63",
          },
        ],
        jobAids: [
          {
            title: "Enroll Employee in Digital Course",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/05f70b93-ab7a-4465-b3f9-81c0cf967407",
          },
          {
            title: "Enroll Employee in Blended Course Offering",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/b53ae3c8-f743-4760-a249-672483fdebbb",
          },
          {
            title: "EL Total Training Hours Summary Report",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/8341bb2d-2756-4e64-8ab8-9abb730be223",
          },
          {
            title: "EL Learning Class Status Report",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/d9739dfb-b6c5-486e-8103-ec0be8b46b6f",
          },
          {
            title: "Drop Employee From Digital Course",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/ebb5bd17-e0af-4ca2-815d-bffb32265034",
          },
          {
            title: "Drop Employee From Blended Course",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0e8a1f03-1aab-4caf-b2ce-64d8ffcbb715",
          },
          {
            title: "Schedule a Blended Course Offering",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/e1c4fd68-f393-4265-adcc-4946e72098bb",
          },
          {
            title: "EL Training Hours Report",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/f0a33334-75da-4cf8-af2e-3e2e833cbe44",
          },
          {
            title: "Upload Media for Course Offerings",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/edf788ac-bdd1-44df-9726-a922a51d2ac2",
          },
        ],
      },
    ],
  },
  {
    title: "Learning",
    icon: payImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "Self Enrollment in Courses of Interest",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/e9b26a45-4c4e-46fd-b25b-b7c293e7fefc",
          },
          {
            title: "Manage Grading & Attendance for Course Offerings",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/9bf90358-f833-4a3c-ab16-0e5168e23d58",
          },
          {
            title: "Identifying Learning Items Needing Completion",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/1f5c80e5-f0d0-4d42-a0d3-2c97a5dd7644",
          },
          {
            title: "How to View My Learning Transcript",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/46dbcfa6-d1de-4c5e-a016-c595c55ece3e",
          },
        ],
        jobAids: [
          {
            title: "Workday Learning Basics",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/7dea3424-b65b-4a40-9119-d8a13de1799a",
          },
          {
            title: "Self Enrollment in Courses of Interest",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0853b397-e093-4ba6-b1c1-1b5f1037876c",
          },
          {
            title: "Manage Grading & Attendance for Course Offerings",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/080de025-b821-407b-b78d-e9f51eb2b39c",
          },
          {
            title: "Identifying Learning Items Needing Completion",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/493c2057-2a2a-49c5-8414-c49a35aa7c62",
          },
          {
            title: "How to View My Learning Transcript",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/4c302cc6-5792-4c55-80a6-d5cd9ff498fb",
          },
          {
            title: "How to Complete Relias Content in Workday",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/c590f061-4edd-4b58-bf29-dd12f227e4a9",
          },
          {
            title: "Manager - Verify Employee Course Completion",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/53027a59-b85b-4026-a7a8-db1da78fea89",
          },
          {
            title: "Manager - Enroll Employee in Digital Course",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/04084fb1-1702-4a58-921a-520d70ae76db",
          },
        ],
      },
    ],
  },
] as CategoryData[];

export default function SDCLinks() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h4">Quick Links for SDCs</Typography>
      <Categories data={categories} />
      <ContactInformation />
    </React.Fragment>
  );
}
